export const PropertyDescriptionTemplate = `
<div class="PropertyDescription">
{{#PropertyDescription.showPage}}
    <div class="first_part">
    <div class="project-page-header">
            <div class="text-wrapper-2">Property Description</div>
            {{#PropertyDescription.data.projectDescriptionData.brochureFile}}
              <div class="frame-3">
                <a href="{{{PropertyDescription.data.projectDescriptionData.brochureFile}}}" target="_blank" class="buttons-button">
                  <img class="download" src="https://replica.psi-crm.com/ProposalIcons/download-03.svg" alt=""/>
                  <div class="text-padding">
                    <div class="">Download Brochure</div>
                  </div>
                </a>
              </div>
            {{/PropertyDescription.data.projectDescriptionData.brochureFile}}
      </div>
      <div class="content">
        <div class="frame">
          {{#PropertyDescription.showGeneralFacts}}
          <div class="div">
            <div class="text-wrapper-2">Project General Facts</div>
            <div class="div-wrapper">
              <p class="experience-the">
                {{PropertyDescription.data.projectDescriptionData.projectDetails.propertyOverView}}
              </p>
            </div>
          </div>
          <div class="div">
            <div class="text-wrapper-2">Project Details</div>
            <div class="div-wrapper">
              <div class="row">
                <div class="col">
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Construction status:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.constructionStatus}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.constructionStatus}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.constructionStatus}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.constructionStatus}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.constructionStatus}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Completion date:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.completionDate}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.completionDate}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.completionDate}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.completionDate}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.completionDate}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Ownership type:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.ownershipType}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.ownershipType}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.ownershipType}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.ownershipType}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.ownershipType}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Master developer:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.masterDeveloper}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.masterDeveloper}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.masterDeveloper}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.masterDeveloper}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.masterDeveloper}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Developed by:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.developedBy}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.developedBy}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.developedBy}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.developedBy}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.developedBy}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Usage:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.usage}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.usage}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.usage}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.usage}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.usage}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Handover:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.handover}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.handover}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.handover}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.handover}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.handover}}
                      </div>
                    </div>
                  </div>
                  <div class="frame-2">
                    <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                    <div class="frame-3">
                      <div class="text">Service charge:</div>
                      <div class="text-2">
                        {{#PropertyDescription.data.projectDescriptionData.projectDetails.serviceCharge}}
                          {{PropertyDescription.data.projectDescriptionData.projectDetails.serviceCharge}}
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.serviceCharge}}
                        {{^PropertyDescription.data.projectDescriptionData.projectDetails.serviceCharge}}
                          -
                        {{/PropertyDescription.data.projectDescriptionData.projectDetails.serviceCharge}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {{/PropertyDescription.showGeneralFacts}}
        </div>
      </div>
    </div>
  {{#PropertyDescription.showProjectFacts}}
    <div class="second_part">
      <div class="overlap-group">
        <div class="frame">
          <div class="text-wrapper">Project Facts</div>
          <div class="row-wrapper">
            <div class="row">
              <div class="col">
                <div class="div">
                  <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                  <div class="frame-2">
                    <div class="text">Total no of floors:</div>
                    <div class="text-2">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfFloors}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfFloors}}
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfFloors}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfFloors}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfFloors}}
                    </div>
                  </div>
                </div>
                <div class="div">
                  <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                  <div class="frame-2">
                    <div class="text">No of units:</div>
                    <div class="text-2">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfUnits}}
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.totalNumberOfUnits}}
                    </div>
                  </div>
                </div>
                <div class="div">
                  <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                  <div class="frame-2">
                    <div class="text">No of residential:</div>
                    <div class="text-2">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfResidentialUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfResidentialUnits}}
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfResidentialUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfResidentialUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfResidentialUnits}}
                    </div>
                  </div>
                </div>
                <div class="div">
                  <img class="arrow-narrow-right" src="https://replica.psi-crm.com/ProposalIcons/arrow-narrow-right.svg" />
                  <div class="frame-2">
                    <div class="text">No of commercial:</div>
                    <div class="text-2">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfCommercialUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfCommercialUnits}}
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfCommercialUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfCommercialUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfCommercialUnits}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="frame-3">
          <div class="text-wrapper">Project Allocation</div>
          <div class="row-wrapper">
            <div class="row">
              <div class="col-2">
                <div class="frame-4">
                  <img class="img" src="https://replica.psi-crm.com/ProposalIcons/building-01.svg" />
                  <div class="frame-5">
                    <div class="text-3">Apartment</div>
                    <div class="text-4">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfApartmentUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfApartmentUnits}}
                        units
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfApartmentUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfApartmentUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfApartmentUnits}}
                    </div>
                  </div>
                </div>
                <div class="frame-4">
                                <img class="img" src="https://replica.psi-crm.com/ProposalIcons/house-modern-svgrepo-com 1.svg" alt=""/>
                  <div class="frame-5">
                    <div class="text-3">Villa</div>
                    <div class="text-4">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfVillaUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfVillaUnits}}
                        units
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfVillaUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfVillaUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfVillaUnits}}
                    </div>
                  </div>
                </div>
                <div class="frame-4">
                                <img class="img" src="https://replica.psi-crm.com/ProposalIcons/briefcase-01.svg" alt=""/>
                  <div class="frame-5">
                    <div class="text-3">Office</div>
                    <div class="text-4">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfOfficeUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfOfficeUnits}}
                        units
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfOfficeUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfOfficeUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfOfficeUnits}}
                    </div>
                  </div>
                </div>
                <div class="frame-4">
                                <img class="img" src="https://replica.psi-crm.com/ProposalIcons/building-07 (1).svg" alt=""/>
                  <div class="frame-5">
                    <div class="text-3">Townhouse</div>
                    <div class="text-4">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfTownhouseUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfTownhouseUnits}}
                        units
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfTownhouseUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfTownhouseUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfTownhouseUnits}}
                    </div>
                  </div>
                </div>
                <div class="frame-4">
                                <img class="img" src="https://replica.psi-crm.com/ProposalIcons/building-08.svg" alt=""/>
                  <div class="frame-5">
                    <div class="text-3">Penthouse</div>
                    <div class="text-4">
                      {{#PropertyDescription.data.projectDescriptionData.projectFacts.numberOfPenthouseUnits}}
                        {{PropertyDescription.data.projectDescriptionData.projectFacts.numberOfPenthouseUnits}}
                        units
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfPenthouseUnits}}
                      {{^PropertyDescription.data.projectDescriptionData.projectFacts.numberOfPenthouseUnits}}
                        -
                      {{/PropertyDescription.data.projectDescriptionData.projectFacts.numberOfPenthouseUnits}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  {{/PropertyDescription.showProjectFacts}}
  {{/PropertyDescription.showPage}}
</div>
`;
